/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommEventDescriptionViewProps } from './ecomm-event-description';

/**
 *
 * EcommEventDescriptionView component
 * @extends {React.PureComponent<IEcommEventDescriptionViewProps>}
 */
export class EcommEventDescriptionView extends React.PureComponent<IEcommEventDescriptionViewProps> {
    public render(): JSX.Element | null {
        return (
            <div className='ecomm-event-description row'>
                <div className='img-gallery col-sm-6'>
                    <div className='img-wrapper'>
                        <img src={this.props.imageUrl} />
                    </div>
                </div>
                <div className='content col-sm-6'>
                    <p className='type'>{this.props.type}</p>
                    <h1 className='name'>{this.props.name}</h1>
                    <p className='description'>{this.props.description}</p>
                    {this._renderButtons()}
                </div>
            </div>
        );
    }

    private _renderButtons(): JSX.Element | null {
        const { config } = this.props;

        let first = null;

        if (config.firstAnchorTargetID) {
            first = (
                <a className='first-button' href={`#${config.firstAnchorTargetID}`}>
                    {config.firstButtonText}
                </a>
            );
        }

        let second = null;

        if (config.secondAnchorTargetID) {
            second = (
                <a className='second-button' href={`#${config.secondAnchorTargetID}`}>
                    {config.secondButtonText}
                </a>
            );
        }

        return (
            <div className='actions'>
                {first}
                {second}
            </div>
        );
    }
}

export default EcommEventDescriptionView;
